import { useEffect, useState } from "react";
import { Button, Modal, Stack, Text, TextInput, Title } from "@mantine/core";

const EditRecordingNameModal = ({
  modalOpened,
  setModalOpened,
  isMobile,
  initialRecordingName,
  setRecordingName,
}: {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  isMobile: boolean;
  initialRecordingName: string;
  setRecordingName: (value: string) => void;
}) => {
  const [value, setValue] = useState(initialRecordingName);
  const ableToSave = value.length > 0 && !value.includes(" ");

  useEffect(() => {
    setValue(initialRecordingName);
  }, [initialRecordingName]);

  return (
    <Modal
      opened={modalOpened}
      fullScreen={isMobile}
      centered
      closeOnEscape={false}
      onClose={() => setModalOpened(false)}
      title={"Save recording"}
      closeOnClickOutside={false}
      withCloseButton={true}
      id="modal-recording"
      size={"lg"}
    >
      <Stack p="md">
        <Stack mt={30} mb={30} gap={5}>
          <Title order={4} fz={18} fw={500} c={"#555"}>
            Recording Name
          </Title>
          <TextInput
            variant="unstyled"
            size="lg"
            fw={600}
            fz={24}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            style={{
              borderBottom: `1px solid #eee`,
            }}
            placeholder="Enter recording name"
          />
          <Text c={"red"} fz={12}>
            {value?.trim().includes(" ") ? "Name cannot contain spaces" : ""}
          </Text>
        </Stack>
        <Button
          w={"100%"}
          fz={16}
          fw={500}
          mt={10}
          disabled={!ableToSave}
          radius={50}
          h={50}
          variant="primary"
          onClick={() => {
            setRecordingName(value);
            setModalOpened(false);
          }}
        >
          Save
        </Button>
      </Stack>
    </Modal>
  );
};

export default EditRecordingNameModal;
